import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import {Box, Card, Flex} from "rebass";
import {maxHeight} from "styled-system";
import PositionBox from './PositionBox'


export const HeaderWrapper = styled(Card)`
	position: relative;
	top: 0;
	left: 0;
	width: 100vw;
	min-height: auto;
	max-height: 182px;
`

const MobileHeaderContainer = styled(Flex)`
	 visibility: hidden;
	 position: fixed;
	 @media (max-width: 700px){
	      visibility: visible;
	      width: 100%;
	      z-index: 9100;
	      display: block;
	      position: initial;
	    //  -webkit-box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
        //-moz-box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
        //box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
	 }
	 	${maxHeight}

`;


const ShadowBox = styled(Box)`
  visibility: hidden;
  z-index: -1;
`;

const MobileHeader = ({children, bg, boxShadow, color, maxHeight, height, width, paddingTop, paddingLeft, paddingRight, paddingBottom, top, zIndex, ...rest}) => {
	return (
		<MobileHeaderContainer pb={1} width={width}>
			<Box bg={bg}>
				<PositionBox color={color} maxHeight={maxHeight} height={height} position='fixed' zIndex={zIndex} bg={bg} top={top} pt={paddingTop} pl={paddingLeft} pr={paddingRight} pb={paddingBottom} left={0} width={1} boxShadow={boxShadow}>
					{children}
				</PositionBox>
			</Box>
			<ShadowBox>{children}</ShadowBox>
		</MobileHeaderContainer>
	);
};

MobileHeader.propTypes = {
	bg: PropTypes.string,
};

MobileHeader.defaultProps = {
	bg: 'white',
	color: 'black',
	boxShadow: 'main',
	maxHeight: 'auto',
	height: 'auto',
	top: '30px',
	paddingTop: '20px',
	paddingLeft: '24px',
	paddingRight: '24px',
	paddingBottom: '',
	zIndex: 9000
};

export default MobileHeader;
